<template>
  <el-tag size="medium" :type="type[1-value]" >{{data[1-value]}}</el-tag>
</template>
<script>
    export default {
        name: 'KcStatusTag',
        props: {
            value: {default: 0},
            data:{default:["是","否"]},
            type:{default:["success","warning"]},
        },
        data() {
            return {

            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/kc/keTemp/KcStatusTag.vue